import { Capacitor } from '@capacitor/core';

const ENVIRONMENT = {
  URL_API_AUTH_LOGIN: {
    TOKEN: '/api-security/v2/token',
    FORGOT_PASSWORD: '/api-users/v1/users/forgot-password-link',
    CHANGE_PASSWORD: '/api-users/v1/me/users/change-password',
    RESET_PASSWORD: '/api-users/v1/users/reset-password',
    // Cambio de clave caducada (USR0032): el usuario aún no tiene sesión
    PASSWORD_CHANGE: '/api-security/v2/change-password',
  },
  URL_API_MERCHANT: '/api-merchant/v3/me',
  URL_API_MERCHANT_APIS: {
    MERCHANTS: '/merchants',
    MERCHANTS_EXPAND: '?expand=commercial_agent',
  },
  URL_API_DASHBOARD: '/api-ecommerce/v2',
  URL_API_ECOMMERCE: '/api-ecommerce/v2',
  URL_API_ECHOP_APIS: {
    URL_API_MERCHANT_ORDERS: '/merchant-orders',
    URL_API_ORDER: '/orders',
  },

  URL_API_DASHBOARD_APIS: {
    DASHBOARD:
      '/dashboards?offset=<offset>&limit=<limit>&order_by=<order>&sort=<sort>',
    DASHBOARD_SETTLEMENTS:
      '/dashboards-settlements',
    DASHBOARD_SETTLEMENTS_FILTERS:
      '?offset=<offset>&limit=<limit>&order_by=<order>&sort=<sort>',
    DASHBOARD_PAID_SUMMARY: '/dashboards-paid-summary',
    DASHBOARD_PROPOSAL: '/dashboards',
  },
  URL_API_OCR: '/api-ocr/v1',
  URL_API_OCR_APIS: {
    OCR_MAIN: '/ocr',
    OCR_NFC: '/ocr/<ocrDocumentId>/nfc',
    OCR_ANALYZE: '/ocr/<ocrDocumentId>/analyze',
  },
  URL_API_ECOMMERCE_APIS: {
    PLATFORM: '/me/ecommerce-platform',
    WIDGET: '/me/ecommerce-widgets',
  },
  URL_COMMERCIAL_OFFER: {
    COMMERCIAL_OFFERS: '/commercial-offers',
  },
  URL_ORDERS: {
    ORDERS: '/orders',
    REFUND: '/refunds',
    SIMULATE_REFUNDS: '/simulate-refunds',
  },
  URL_LOANS: {
    API_LOAN: '/api-loan/v1',
    LOANS: '/loans',
    REFUND_LOAN: '/refunds',
    SIMULATE_REFUNDS_LOAN: '/simulate-refunds',
  },
  URL_FINANCIAL: {
    API_FINANCIAL: '/api-financial/v3',
    SIMULATIONS: '/loan-simulations?currency=EUR',
  },
  URL_CONFIG: {
    API_CONFIG: '/api-config/v1',
    COUNTRY_LIST: '/keys?group=PAI',
    LABOR_STATUS: '/keys?group=A07',
    STREET_TYPES: '/keys?group=VIA',
    CITIES: '/cities?postal_code=',
  },
  URL_PROPOSAL: {
    API_CREDIT_PROPOSAL: '/api-credit-proposal/v1',
    PROPOSAL: '/credit-proposals',
    CUSTOMER_CLASSIFICATION: '/customer-classification',
    DECISION: '/decisions',
    NOTIFICATIONS: '/notifications',
  },
  DATA_PROVIDER_SECURITY: {
    API_KEY: Capacitor.isNativePlatform()
      ? import.meta.env.VITE_API_KEY : import.meta.env.VITE_API_WEB_KEY,
    API_SECRET: Capacitor.isNativePlatform()
      ? import.meta.env.VITE_API_SECRET : import.meta.env.VITE_API_WEB_SECRET,
  },

  URL_API_NOTIFICATION: '/device/v1',
  URL_API_NOTIFICATION_APIS: {
    REGISTRATION: '/registration',
    RETRIEVE: `/${import.meta.env.VITE_SFMC_APP_ID}/sync/<deviceId>`,
  },
  PAYMENTS_URL: {
    URL_OK: `${import.meta.env.VITE_URL_PEPPERONE}/#/payment-check?paymentOk`,
    URL_KO: `${import.meta.env.VITE_URL_PEPPERONE}/#/payment-check`,
    URL_CANCEL: `${import.meta.env.VITE_URL_PEPPERONE}/#/payment-check`,
  },
  URL_SIGNALR: import.meta.env.VITE_URL_SIGNALR,
  BASE_URL_VERSION_CONTROL: import.meta.env.VITE_BASE_URL_VERSION_CONTROL,
  URL_VERSION_CONTROL: '/versionControl/appMerchants_vc.json',
  FIREBASE_API_KEY: import.meta.env.VITE_NOTIFICATIONS_API_KEY,
  FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_NOTIFICATIONS_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: import.meta.env.VITE_NOTIFICATIONS_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_NOTIFICATIONS_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VITE_NOTIFICATIONS_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: import.meta.env.VITE_NOTIFICATIONS_APP_ID,
  FIREBASE_MEASUREMENT_ID: import.meta.env.VITE_NOTIFICATIONS_MEASUREMENT_ID,
  CLARITY_KEY: import.meta.env.VITE_CLARITY_KEY,
  CLARITY_KEY_WEB: import.meta.env.VITE_CLARITY_KEY_WEB,
  BIOMETRIC_SERVER: import.meta.env.VITE_BIOMETRIC_SERVER,
  IOS_DOWNLOAD_LINK: import.meta.env.VITE_IOS_DOWNLOAD_LINK,
  ANDROID_DOWNLOAD_LINK: import.meta.env.VITE_ANDROID_DOWNLOAD_LINK,
  BASE_URL: import.meta.env.VITE_BASE_URL,
  URL_API_LEADS: `${import.meta.env.VITE_BASE_URL}/api-security/v2/leads`,
  CONEXION_STRING: import.meta.env.VITE_INSIGHTS_CONEXION_STRING,
  URL_PEPPERONE: import.meta.env.VITE_URL_PEPPERONE,
  URL_PEPPEREXPRESS: import.meta.env.VITE_URL_PEPPEREXPRESS,
  NOTIFICATIONS_BASE_URL: import.meta.env.VITE_NOTIFICATIONS_BASE_URL,
  SFMC_APP_ID: import.meta.env.VITE_SFMC_APP_ID,
  VAPID_KEY: import.meta.env.VITE_NOTIFICATIONS_VAPID_KEY,
  URL_API_SECURITY: '/api-security/v2',
  URL_TERMS: import.meta.env.VITE_URL_TERMS,
  URL_PRIVACY_POLICY: import.meta.env.VITE_URL_PRIVACY_POLICY,
  ENV: import.meta.env.VITE_ENV,
  IDNIECAP_LICENSE: import.meta.env.VITE_IDNIECAP_LICENSE,
  MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  ECOMMERCE_WIDGET_STYLE: import.meta.env.VITE_ECOMMERCE_WIDGET_STYLE,
  URL_ECOMMERCE: import.meta.env.VITE_URL_ECOMMERCE,
  URL_ECOMMERCE_2: import.meta.env.VITE_URL_ECOMMERCE_2,
  URL_ECO: import.meta.env.VITE_URL_ECO,
  URL_ECO_2: import.meta.env.VITE_URL_ECO_2,
};

export default ENVIRONMENT;
